export const printConfig = `
@media print {
    @page {
        size: A4;
        margin: 0.1in;
    }
    
    body * {
        visibility: hidden;
    }
    .report-content, .report-content * {
        visibility: visible;
    }
    .report-content {
        position: absolute;
        left: 0 !important;
        top: 0 !important;
        width: 100% !important;
        transform: none !important;
        background: white !important;
        margin: 0 !important;
        padding: 0 !important;
    }
    
    .print-hide {
        display: none !important;
    }
    
    .print-only {
        display: block !important;
    }
    
    .pdf-header {
        z-index: 1000 !important;
    }
    
    .pdf-header img {
        height: 60px !important;
        width: auto !important;
    }
    
    .report-section {
        page-break-inside: auto !important;
        break-inside: auto !important;
        margin-bottom: 20px !important;
    }

    .report-section:first-child {
        margin-top: 60px !important;
    }

    .collapse-container__card {
        page-break-inside: auto !important;
        break-inside: auto !important;
        margin-bottom: 15px !important;
    }
    
    .ant-table {
        page-break-inside: auto !important;
    }
    
    .ant-table-thead > tr > th {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    .ant-table-thead {
        page-break-after: avoid !important;
    }
    
    .ant-table-tbody > tr {
        page-break-inside: auto !important;
        break-inside: auto !important;
    }
    
    canvas, img {
        max-width: 100% !important;
        height: auto !important;
        page-break-inside: avoid !important;
    }
    
    * {
        -webkit-print-color-adjust: exact !important;
        color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
    
    body {
        font-size: 12px !important;
        line-height: 1.4 !important;
    }
    
    h1, h2, h3, h4, h5, h6 {
        page-break-after: avoid !important;
        margin-bottom: 10px !important;
    }
    
    .chart-container {
        page-break-inside: avoid !important;
        margin: 10px 0 !important;
    }
    
    .ant-card {
        margin-bottom: 15px !important;
        box-shadow: none !important;
    }
    
    .ant-card-body {
        padding: 12px !important;
    }
    
    .ant-table-expanded-row {
        page-break-inside: auto !important;
    }
}

@media screen {
    .print-only {
        display: none !important;
    }
}
`;
